import React, { useEffect, useState } from 'react';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import { useDispatch } from 'react-redux';
import { DEFAULT_END_AT, DEFAULT_START_AT } from '../../../LogManagement/constants';
import { Helmet } from 'react-helmet';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import Visible from '../../../../components/Custom/Visible';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';
import BOTable from '../../../../components/Tables/BOTable';
import Notification from '../../../../components/Notification/Notification';
import { basicMissionLogListRequest } from '../../../../redux/actions/log/basicMissionLogActions';
import useSchemaBasicMissionLog from '../../../../schema/table-schema/useSchemaBasicMissionLog';
import {
    SearchBtnContainer,
    SearchContainer, SearchContent,
    SearchDateRange,
    SearchLabel,
    SearchRow
} from "../../../../components/Search/searchSection";
import {UIConstants} from "../../../../constants/UIConstants";

function BasicMissionLogMain() {
  // -- component const --//
  // 페이지 제목
  const title = '베이직 미션 로그';
  const OPTION_KEY = Page.APP_BASIC_MISSION_REWARD_LOG;
  const { schema } = useSchemaBasicMissionLog();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [tBody, setTbody] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [pageLength, setPageLength] = useState(25);
  const [page, setPage] = useState(1);

  const [beginDate, setBeginDate] = useState(DEFAULT_START_AT);
  const [endDate, setEndDate] = useState(DEFAULT_END_AT);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // 검색
  const [accountNo, setAccountNo] = useState(0);
  const [missionIndex, setMissionIndex] = useState(0);
  const [isReset, setIsReset] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      basicMissionLogListRequest({
        page: page,
        pageLength: Number(pageLength),
        beginDate: beginDate,
        endDate: endDate,
        accountNo: accountNo,
        missionIndex: missionIndex,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setIsLoading(false);

          // 인덱스를 추가하여 새로운 배열을 생성(중복 키 방지)
          const listWithIndex = data?.list.map((item, index) => ({
            index: index + 1, // 인덱스는 1부터 시작(번호 표기시 편의를 위해)
            ...item,
          }));

          setTbody(listWithIndex);

          setTotalCount(data.totalCount);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
          setIsLoading(false);
        },
      }),
    );
  };

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(value);
    setPage(1);
  };

  const handleSearchClick = () => {
    if (page === 1) {
      fetchList();
      return;
    }

    setPage(1);
  };

  const handleResetClick = () => {
      setAccountNo(0);
      setMissionIndex(0);
      setIsReset(true);
  }

  // -- react hooks --//
  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

  useEffect(() => {
      if(isReset){
          setIsReset(false);
          fetchList();
      }
  }, [isReset])

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <section className="topSection">
          <div className="leftSection">
              <p className="titleText">{title}</p>
          </div>
      </section>

      <div className="spaceDiv10"/>

        <section>
            <SearchContainer>
                <SearchRow>
                    <SearchLabel text={UIConstants.Date}/>
                    <SearchDateRange
                        startAt={beginDate}
                        endAt={endDate}
                        setStartAt={setBeginDate}
                        setEndAt={setEndDate}
                    />
                </SearchRow>

                <SearchRow>
                    <SearchLabel text={UIConstants.UserId}/>
                    <SearchContent>
                        <input
                            className=""
                            value={accountNo === 0 ? '' : accountNo}
                            placeholder="유저 ID"
                            onChange={(e) => {
                                setAccountNo(Number(e.target.value));
                            }}
                        />
                    </SearchContent>
                    <SearchLabel text={"미션 인덱스"}/>
                    <SearchContent>
                        <input
                            className=""
                            value={missionIndex === 0 ? '' : missionIndex}
                            placeholder="MISSION INDEX"
                            onChange={(e) => {
                                setMissionIndex(Number(e.target.value));
                            }}
                        />
                    </SearchContent>
                </SearchRow>
            </SearchContainer>

            <SearchBtnContainer
                handleSearchClick={handleSearchClick}
                handleResetClick={handleResetClick}
            />
        </section>

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.top_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />

        <div className="spaceDiv10"/>
      </Visible>

      <div className="spaceDiv10"/>

      <BOTable
        schema={schema}
        rows={tBody}
        loading={isLoading}
        onClick={null}
      />

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.bottom_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default BasicMissionLogMain;
